import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef, NbGetters, NbMenuItem, NbTreeGridDataSource, NbTreeGridDataSourceBuilder } from '@nebular/theme';
import { AngularTreeGridComponent } from 'angular-tree-grid';

interface TreeNode<T> {
  //item: T;
  //children?: TreeNode<T>[];
  expanded?: boolean;
}
interface FSEntry {
  title: string;
  hidden?: boolean;
  contentId?: string;
  parentContentId?:string
  link?: string;
  children?: FSEntry[];
  expanded?: boolean;
}

@Component({
  selector: 'ngx-menu-item-editor-dialog',
  templateUrl: './menu-item-editor-dialog.component.html',
  styleUrls: ['./menu-item-editor-dialog.component.scss']
})
export class MenuItemEditorDialogComponent implements OnInit {
  @Input() item:NbMenuItem;
  data:any;
  configs: any = {
    id_field: 'contentId',
    parent_id_field: 'parentContentId',
    parent_display_field: 'parentContentId',
    header_class:'tree-table-header',
    table_class:'tree-table-table',
    actions: {
      add: true,
      edit: true,
      delete: true,
      edit_parent: true,
    },
    columns: [
      {
        name: 'title',
        header: 'Ttile',
      },
      {
        name:'hidden',
        header:'Show'
      },
      {
        name:'link',
        header:'Link'
      },
      {
        name: 'contentId',
        header: 'Content Id',
        renderer: function(value) {
          return value
        }
      },
      {
        name: 'parentContentId',
        header: 'Parent Content Id',
        renderer: function(value) {
          return value
        }
      }
    ],
    css: {
      expand_icon: '<i class="fa fa-caret-right"> </i>',
      collapse_icon: '<i class="fa fa-caret-down"> </i>',
      add_icon: '<i class="fa fa-plus"> </i>',
      edit_icon: '<i class="fa fa-pencil"> </i>',
      delete_icon: '<i class="fa fa-trash"> </i>',
      save_icon: '<i class="fa fa-save"> </i>',
      cancel_icon: '<i class="fa fa-remove"> </i>',
    }
  };
  isLoaded = false;
  //@Input() title:ContentElement;
  //@Input() dialogWidth:number;
  defaultColumns = [ 'title', 'hidden', 'link' ];
  source: NbTreeGridDataSource<FSEntry>;
  //data: TreeNode<NbMenuItem>[] = [];

  @ViewChild('angularGrid') angularGrid: AngularTreeGridComponent;

  constructor(protected ref: NbDialogRef<MenuItemEditorDialogComponent>){}
  
  ngOnInit(): void {
    //let data = this.convertData(this.item);
    console.log(this.item);
    //let flattenItem = this.flattenDataProperty(this.item);
    //let data = [{flattenItem}];
    //console.log(flattenItem);
    let flattenItems = this.flattenItems([this.item]);
    console.log(flattenItems);
    this.data = this.flattenObjects(flattenItems);

    console.log(this.data);
  }

  convertData(item:NbMenuItem):any[]{
    let result = [];
    let _item = Object.assign
    return result;
  }

  // Function to flatten the array

  flattenDataProperty(item: NbMenuItem): any {
    //const result = {};
    // Helper function to recursively flatten items
    let result = this.flatten({},item); // Start flattening from the top level
    console.log(result);
    return result;
  }

  flatten(result:any,itemObject: NbMenuItem) {
    Object.entries(itemObject).map(entry => {
      let key = entry[0];
      let value = entry[1];
      switch (key) {
        case "data":
          if(value["contentId"] != undefined){
            result["contentId"] = value["contentId"];
          }
          if(value["parentContentId"] != undefined){
            result["parentContentId"] = value["parentContentId"];
          }            
          break;
        case "children":
          let children:any[] = [];
          let _children:NbMenuItem[] = value;
          _children.forEach(child => {
            let childResult = this.getChildResult(child);
            //const childResult = flatten(child);
            console.log(childResult);
            children.push(childResult)
           })
          console.log(children);
          result["children"] = children;
          break;
        default:
          result[key] = value;
          break;
      }
      
      //console.log(key, value);
    });
    return result
  }

  getChildResult(child:NbMenuItem):any{
    console.log(child);
    let childResult = {};
    Object.entries(child).map(entry => {
      let key = entry[0];
      let value = entry[1];
      switch (key) {
        case "data":
          if(value["contentId"] != undefined){
            childResult["contentId"] = value["contentId"];
          }
          if(value["parentContentId"] != undefined){
            childResult["parentContentId"] = value["parentContentId"];
          }            
          break;
        case "children":
          let children:any[] = [];
          let _children:NbMenuItem[] = value;
          _children.forEach(child => {
            let childResult = this.getChildResult(child);
            //const childResult = flatten(child);
            console.log(childResult);
            children.push(childResult)
           })
          console.log(children);
          childResult["children"] = children;
          break;
        default:
          childResult[key] = value;
          break;
      }
      
      //console.log(key, value);
    });
    return childResult;
  }

  flattenObjects(flattenItems:NbMenuItem[]){
    const result: any[] = [];
    flattenItems.forEach((itemObject:any) => {
      Object.entries(itemObject).map(entry => {
        let key = entry[0];
        let value = entry[1];
        switch (key) {
          case "data":
            if(value["contentId"] != undefined){
              itemObject["contentId"] = value["contentId"];
            }
            if(value["parentContentId"] != undefined){
              itemObject["parentContentId"] = value["parentContentId"];
            }
            delete itemObject.data;
            break;
          case "children":
            delete itemObject.children;            
            break;
        
          default:
            break;
        }
      })
      result.push(itemObject)
    })
    this.isLoaded = true;
    return result
  }

  // Function to flatten the array
  flattenItems(items: NbMenuItem[]): NbMenuItem[] {
    const result: NbMenuItem[] = [];
    
    // Helper function to recursively flatten items
    function flatten(itemArray: NbMenuItem[]) {
      for (const item of itemArray) {
        result.push(item); // Add the current item
        if (item.children) {
          flatten(item.children); // Recursively flatten the children
        }
      }
    }

    flatten(items); // Start flattening from the top level
    return result;
  }

  onAdd(e){
    console.log("onAdd",e);
  }

  

}
